<template lang="pug">
.crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
  modal-requisitioners(:form='form', :is-add='true')
  modal-branches(:form='branchModal', :is-add='true')
  modal-quotation-contacts(:form='form', :is-add='true')
  .container-fluid
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], push: true, focus: true, disabled: stepValidations.valid },]")
      stepper-component(class="stepper" @done='saveDataQuotation' :previous-text="$t('quotations.previous')" :save-next-text="$t('quotations.next')" :save-text="$t('quotations.save') " v-model='step')
        vm-stepper-header
          vm-stepper-step(step='1' editable :validate="stepValidations.valid && stepValidations.step >= 1")
            div(:class="['stepper-custom', { 'stepper-custom--progress': step === 1, 'stepper-custom--completed': step > 1 }]")
              .stepper-custom__icon
                vm-icon(icon="clipboard-outline" size="1.2rem")
              span.stepper-custom__text {{ $t('quotations.step_one') }}
              span.stepper-custom__title {{ $t('quotations.master_data') }}
              span.stepper-custom__status {{ step === 1 ? $t('quotations.progress') : $t('quotations.complete') }}
          vm-divider(:color="step > 1 ? '#15DD73': 'rgba(0, 0, 0,.1)' " borderHeight="2px" class="stepper-custom__divider")
          vm-stepper-step(step='2' editable :validate="stepValidations.valid && stepValidations.step >= 2")
            div(:class="['stepper-custom', { 'stepper-custom--progress': step === 2, 'stepper-custom--completed': step > 2, 'stepper-custom--pending': step < 2 }]")
              .stepper-custom__icon
                vm-icon(icon="search-outline" size="1.2rem")
              span.stepper-custom__text {{ $t('quotations.step_two') }}
              span.stepper-custom__title {{ $t('quotations.details_data') }}
              span.stepper-custom__status {{ step <= 2  ? $t('quotations.pending') : $t('quotations.complete') }}
          vm-divider.stepper-divider
          vm-stepper-step(step='3' editable)
            div(:class="['stepper-custom', { 'stepper-custom--progress': step === 3, 'stepper-custom--completed': step > 3, 'stepper-custom--pending': step < 3 }]")
              .stepper-custom__icon
                vm-icon(icon="file-add-outline" size="1.2rem")
              span.stepper-custom__text {{ $t('quotations.step_three') }}
              span.stepper-custom__title {{ $t('quotations.extra_information') }}
              span.stepper-custom__status {{ step <= 3  ? $t('quotations.pending') : $t('quotations.complete') }}
          vm-divider.stepper-divider
          vm-stepper-step(step='4' editable)
            div(:class="['stepper-custom', { 'stepper-custom--progress': step === 4, 'stepper-custom--completed': step > 3, 'stepper-custom--pending': step < 4 }]")
              .stepper-custom__icon
                vm-icon(icon="file-add-outline" size="1.2rem")
              span.stepper-custom__text {{ $t('quotations.step_four') }}
              span.stepper-custom__title {{ $t('quotations.summary') }}
              span.stepper-custom__status {{ step <= 3  ? $t('quotations.pending') : $t('quotations.complete') }}
        vm-stepper-items.card
          Loader(v-if="loader")
          vm-stepper-content(step='1')
            quotation-master-data-form(:form="form" @onValidate="onValidateStep" @modalBranches="modalBranches")
          vm-stepper-content(step='2')
            quotation-master-detail-form(@onValidate="onValidateStep")
          vm-stepper-content(step='3')
            quotation-extra-information-form(:form="form" :isEdit="isEdit" @onChange="onUploadFile")
          vm-stepper-content(step='4')
            quotation-summary-form(:form="form")
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')
const QuotationMasterDataForm = () => import('@/components/forms/QuotationMasterDataForm.vue')
const QuotationMasterDetailForm = () => import('@/components/forms/QuotationMasterDetailForm.vue')
const QuotationExtraInformationForm = () => import('@/components/forms/QuotationExtraInformationForm.vue')
const QuotationSummaryForm = () => import('@/components/forms/QuotationSummaryForm.vue')
const Loader = () => import('@/components/aditionals/Loader.vue')
const ModalRequisitioners = () => import('@/components/modals/ModalRequisitioners.vue')
const ModalBranches = () => import('@/components/modals/ModalBranches.vue')
const ModalQuotationContacts = () => import('@/components/modals/ModalQuotationContacts.vue')
const StepperComponent = () => import('@/components/StepperComponent.vue')

export default {
  name: 'CreateQuotes',
  components: {
    QuotationMasterDataForm,
    QuotationMasterDetailForm,
    QuotationExtraInformationForm,
    QuotationSummaryForm,
    Loader,
    ModalRequisitioners,
    ModalBranches,
    ModalQuotationContacts,
    StepperComponent
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    status: [],
    step: 1,
    file: {},
    stepValidations: {
      valid: false,
      step: 1
    },
    form: {
      exchange_rate: 1,
      files: [],
      comments: '•',
      branchIds: '',
      payment_conditions: ''
    },
    branchModal: []
  }),
  computed: {
    ...mapGetters(['details', 'quotation', 'currencies', 'loader']),
    isEdit () {
      return Boolean(this.$route.params.id)
    }
  },
  watch: {
    step (step) {
      if ('customer' in this.form && step === 1) {
        this.stepValidations = {
          valid: true,
          step
        }
      }
      if (step === 2) {
        this.stepValidations = {
          valid: Boolean(this.details.length),
          step
        }
      }
    }
  },
  async created () {
    this.setLoaderVisible(true)
    await this.setProductDetails([])
    await this.loadCurrenciesCatalog()
    if (this.isEdit) {
      await this.loadQuotation(this.$route.params.id)
      this.step = 4
      this.form = {
        ...this.quotation,
        requisitionersIds: [...this.quotation.requisitioners.map(requisitioner => requisitioner.id)],
        branchIds: this.quotation.branch.length ? this.quotation.branch[0].id : ''
      }
    }
    this.setLoaderVisible(false)
  },
  methods: {
    ...mapActions([
      'loadQuotation',
      'saveQuotition',
      'setProductDetails',
      'updateQuotition',
      'loadCurrenciesCatalog',
      'setLoaderVisible',
      'setModalBranchesVisible'
    ]),
    onValidateStep (values) {
      this.stepValidations = values
    },
    onUploadFile (files) {
      this.form.files = files
    },
    saveDataQuotation () {
      !this.isEdit ? this.saveQuotition({ form: { ...this.form, details: this.details } }) : this.updateQuotition({ form: { ...this.form, details: this.details } })
    },
    modalBranches () {
      this.branchModal = {
        customer_id: this.form.customer.id
      }
      this.setModalBranchesVisible(true)
    }
  }
}
</script>

<style lang="scss">
.stepper {
  width: 100%;
  &-custom {
  display: flex;
  flex-direction: column;
    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 53px;
      height: 53px;
      border-radius: 50%;
      padding: 18px;
      margin-bottom: 36px;
    }
    &__text {
      font-size: 13px;
      font-weight: 500px;
      margin-bottom: 8px;
    }
    &__title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 12px;
    }
    &__status {
      font-size: 14px;
      font-weight: 500;
      padding: 4px 8px;
    }
    &__divider {
      align-items: flex-start;
      padding-top: 30px;
    }
    &--progress {
      & .stepper-custom {
        &__icon {
          border: 1px solid rgba($color: var(--primary), $alpha: 1.0);
        }
        &__text {
          color: #929292;
        }
        &__title {
          color: #242424;
        }
        &__status {
          color: #D06325;
        }
      }
    }
    &--pending {
      & .stepper-custom {
         &__icon {
          border: 1px solid rgba($color: var(--gray), $alpha: 1.0);
        }
        &__text {
          color: #B1B1B1;
        }
        &__title {
          color: #B1B1B1;
        }
        &__status {
          color: #B1B1B1;
          border-radius: 5px;
          border: 1px solid #B1B1B1;
          text-align: center;
        }
      }
    }
    &--completed {
      & .stepper-custom {
        &__icon {
          border: 1px solid rgba($color: #1EC772, $alpha: 1.0);
          background-color: #1EC772;
          color: white;
        }
        &__text {
          color: #929292;
        }
        &__title {
          color: #242424;
        }
        &__status {
          color: #1EC772;
        }
      }
    }
  }
}

.vm-stepper__step__step {
  display: none;
}
.stepper-divider {
  padding-bottom: 8rem;
}
.card {
  margin: 40px 0;
  background: white;
  padding: 5px;
  border-radius: 15px;
  box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, 0.11);
  .form {
    .con-select {
      width: 100%;
    }
  }
  .vm-con-table {
    width: 100%;
  }
}
.description {
  color: #929292;
}

.div__quotation {
  padding: 0 20px 0 0;
}
.radio-section {
  display: flex;
  .radio-item {
    margin: 5px 15px;
  }
}
/* appearance for checked radiobutton */
input[type="radio"]:active {
  background-color: #15DD73;
}
.vm-select--label {
  font-weight: bold;
  color: #000;
}
.vm-input--label {
  font-weight: bold;
  color: #000;
}
.vm-typeahead--label {
  font-weight: bold;
  color: #000;
}
.button_add {
  background-color: #000 !important;
}
.table_products {
  background-color: #F2F4F7;
  .vm-table--tbody-table .tr-table tr {
    background-color: #F2F4F7 !important;
  }
}
.vm-button-primary.vm-button-default {
  background: white !important;
  color: black !important;
  border: 1px solid rgba($color: black, $alpha: 1.0);
  font-weight: 600;
  border-radius: 15px;
}
</style>
